import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/Home.vue'
import LoginView from '../views/Login.vue'
import { supabase } from '../../supabase.js';
import DossierForm from '@/components/DossierForm.vue';
import PatientTodos from '@/components/PatientTodos.vue';
import EditDossier from '@/views/EditDossier.vue';
import DiagnosticDiscussions from '@/components/DiagnosticDiscussions.vue';
import PhoneDirectory from '@/components/PhoneDirectory.vue';
import Calculators from '@/components/Calculators.vue';


const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: { requiresAuth: true } // Mark this route as requiring authentication
  },
  {
    path: '/login',
    name: 'login',
    component: LoginView
  },
  {
    path: '/dossier', name: 'dossier', component: DossierForm,
    meta: { requiresAuth: true },
    props: true // Automatically pass route params as props
  },

  {
    path: '/todos', name: 'todos', component: PatientTodos,
    meta: { requiresAuth: true },
    props: true // Automatically pass route params as props
  },
  {
    path: '/dossier/edit/:id', // Route with parameter for dossier ID
    name: 'edit-dossier',
    component: EditDossier,
    meta: { requiresAuth: true },
    props: true // Automatically pass route params as props (though we use useRoute() here)
  },
  {
    path: '/discussions',
    name: 'discussions',
    component: DiagnosticDiscussions,
    meta: { requiresAuth: true } // Protected route
  },
  {
    path: '/annuaire', // Or '/contacts' etc.
    name: 'phone-directory',
    component: PhoneDirectory,
    meta: { requiresAuth: true } // Usually needs auth
  },
  {
    path: '/calculators',
    name: 'calculators',
    component: Calculators,
    meta: { requiresAuth: true } // Usually needs auth
  },
]

const router = createRouter({
  // history: createWebHistory(import.meta.env.BASE_URL), // <--- THIS IS THE PROBLEM LINE
  history: createWebHistory(process.env.BASE_URL),      // <--- Correct for Vue CLI
  routes
});

// Navigation Guard
router.beforeEach(async (to, from, next) => {
  const { data: { session } } = await supabase.auth.getSession();
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);

  if (requiresAuth && !session) {
    next({ name: 'login' });
  } else if (!requiresAuth && session && to.name === 'login') {

    next({ name: 'home' });
  }
  else {
    next();
  }
})

export default router